module.exports = __webpack_public_path__ + "static/media/19ESCAP36.172c6316.jpg";